import React from 'react'

const NotFound = () => {
  return (
    <div className='flex flex-col items-center justify-center h-screen text-2xl font-bold text-blue-700'>NotFound</div>
  )
}

export default NotFound